export default function DashboardSectionCard({ title, subtitle, icon, colorKey, action, children }) {
  const COLORS = {
    blue:   "#2563EB",
    green:  "#16A34A",
    amber:  "#D97706",
    purple: "#7C3AED",
    pink:   "#BE185D",
    cyan:   "#0E7490",
  };
  const color = COLORS[colorKey] || COLORS.blue;

  return (
    <div style={{ background:"var(--fc-card-bg)", border:"1px solid var(--fc-card-border)", borderRadius:16, height:"100%", display:"flex", flexDirection:"column", overflow:"hidden", boxShadow:"var(--fc-card-shadow)" }}>

      {/* Header */}
      <div style={{ padding:"14px 16px", borderBottom:"1px solid var(--fc-border-light)", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
        <div style={{ display:"flex", alignItems:"center", gap:9 }}>
          <div style={{ width:32, height:32, borderRadius:9, background:color+"15", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
            <i className={`fa-solid ${icon}`} style={{ fontSize:14, color }} />
          </div>
          <div>
            <div style={{ fontSize:13, fontWeight:700, color:"var(--fc-text-primary)", lineHeight:1.2 }}>{title}</div>
            {subtitle && <div style={{ fontSize:11, color:"var(--fc-text-subtle)", marginTop:1 }}>{subtitle}</div>}
          </div>
        </div>
        {action}
      </div>

      {/* Body */}
      <div style={{ padding:"12px 16px", flex:1 }}>
        {children}
      </div>
    </div>
  );
}
